import React, { useEffect, useState } from 'react';

import { MediaDropBox, popupModel } from 'src/components/complex';
import { checkAvatarDimension, getFileInfoFromUri, remCss, useScreenDetail } from 'src/helpers';

export const formatFileReq = (req, avatar, images) => {
  req.haveFiles = true;
  req.avatar = avatar || '';
  req.files = (images || [])
    .filter((item) => typeof item !== 'string' && !item.uri)
    .map((item) => item.file || item);
  req.images = (images || []).filter((item) => typeof item === 'string' || !!item.uri);
};

export const AvatarImages = ({
  avatar,
  invalid,
  onAvatarChange,
  onImagesChange,
  images = [],
  imagesEnable = true,
  width = 128,
  height = 150,
  gap = 10,
  mainImageSpan = 2,
  fixedColumn = 4
}) => {
  avatar =
    avatar && avatar !== ''
      ? typeof avatar === 'string'
        ? { uri: avatar, type: 'image' }
        : avatar
      : '';
  const [containerElement, setContainerElement] = useState(null);
  const [containerWidth, setContainerWidth] = useState(0);

  useScreenDetail();

  useEffect(() => {
    if (!containerElement) return undefined;

    const updateWidth = (nextWidth = containerElement.clientWidth || 0) => {
      setContainerWidth((currentWidth) => (currentWidth === nextWidth ? currentWidth : nextWidth));
    };

    updateWidth();

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', updateWidth);
      return () => window.removeEventListener('resize', updateWidth);
    }

    const resizeObserver = new ResizeObserver((entries) => {
      updateWidth(entries[0]?.contentRect?.width || containerElement.clientWidth || 0);
    });

    resizeObserver.observe(containerElement);

    return () => resizeObserver.disconnect();
  }, [containerElement]);

  const style = {
    dropBoxStyles: {
      width: '100%',
      height: '100%',
      borderRadius: 5,
      padding: 0
    }
  };

  let rotate = 1;

  if (containerWidth) {
    let col = (containerWidth - gap) / width;
    if (col < fixedColumn) {
      rotate = containerWidth / ((width + gap) * fixedColumn - (gap - 1));
    } else {
      rotate = containerWidth / ((width + gap) * Math.floor(col) - (gap - 1));
    }
  }

  let w = width * rotate;
  let h = height * rotate;

  const main = (
    <MediaDropBox
      template={3}
      name={'avatar'}
      labelIcon='Add File'
      multi={false}
      value={avatar !== '' ? [avatar] : []}
      fileBoxProps={{
        styles: {
          width: remCss(w * mainImageSpan + gap * rotate),
          height: remCss(h * mainImageSpan + gap * rotate)
        },
        showFileName: false
      }}
      accept={{
        'image/*': []
      }}
      dropBoxStyles={style.dropBoxStyles}
      style={{
        gridRow: 'span 2',
        gridColumn: 'span 2'
      }}
      invalid={invalid}
      onChange={async (n, v) => {
        if (v[0]) {
          if (!(await checkAvatarDimension(v[0]))) return;

          popupModel.openCropImage({ src: v[0], onSave: onAvatarChange });
        } else onAvatarChange('');
      }}
    />
  );

  return (
    <div style={{ width: '100%' }} ref={setContainerElement}>
      {imagesEnable ? (
        <MediaDropBox
          prefixExpand={main}
          template={3}
          name={'images'}
          labelIcon='Add File'
          multi={true}
          value={images.map(getFileInfoFromUri)}
          accept={{
            'image/*': [],
            'video/*': []
          }}
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(auto-fill, ${remCss(w)}px)`,
            gridAutoRows: remCss(h),
            gap: remCss(gap * rotate)
          }}
          fileBoxProps={{
            styles: {
              width: remCss(w),
              height: remCss(h)
            },
            showFileName: false
          }}
          dropBoxStyles={style.dropBoxStyles}
          invalid={invalid}
          onChange={(n, v) => {
            onImagesChange(v);
          }}
        />
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(auto-fill, ${remCss(w)}px)`,
            gridAutoRows: remCss(h),
            gap: remCss(gap * rotate)
          }}
        >
          {main}
        </div>
      )}
    </div>
  );
};
